/* eslint-disable no-lonely-if */
/* eslint-disable dot-notation */
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import {
  Container,
  Typography,
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Button
} from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import '../stylemod.css';
// hooks
import useResponsive from '../../hooks/useResponsive';
import logoImage from '../../media/login/logo.png';
import bg4 from '../../media/login/bg.jpeg';
import Iconify from '../../components/iconify';
import axios from '../../utils/axios';
import UIContext from '../../context/UIContext';
import ForgotPassword from './ForgotPassword';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundImage: `url("${bg4}")`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  mixBlendMode: 'multiply',
}));
const date = new Date();
const currentYear = date.getFullYear();
const fiscalYears = Array.from({ length: 10 }, (_, i) => {
  const startYear = currentYear - i;
  const endYear = startYear + 1;
  return `${startYear} - ${endYear}`;
});

// const Countrys = {
//   'INDIA - UNITED KINGDOM': 'IN-UK',
//   'INDIA - SRILANKA': 'IN-SL',
//   'UNITED KINGDOM - INDIA': 'UK-IN',
//   'UNITED KINGDOM - SRILANKA': 'UK-SL',
// };

const Countrys = {
  'INDIA - Overall': 'IN',
  'UK - Overall': 'UK',
  'SRILANKA - Overall': 'SL',
};
// Initial values and validation schema for Formik
const loginInitialValue = {
  usercode: '',
  password: '',
  Country: '',
};

const minimalValidationSchema = Yup.object().shape({
  usercode: Yup.string().required('Enter your username'),
  password: Yup.string().max(15, 'Password is too long').required('Enter your password'),
  Country: Yup.string().required('Select country of origin'),
});

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');
  const navigate = useNavigate();
  const [showUserPassword, setShowUserPassword] = useState(false);
  const [error, setError] = useState('');
  const [errorColor, setErrorColor] = useState('');
  const [loading, setLoading] = useState(false);
  const [validationSchema, setValidationSchema] = useState(minimalValidationSchema);
  const [loginType, setLoginType] = useState('');
  const [loginData, setLoginData] = useState([]);
  const [forgotPassword, setForgotPassword] = useState(false);
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  const loginStatus = (msg, color, userDatas) => {
    setError(msg);
    setErrorColor(color);
    if (userDatas) {
      axios.defaults.headers.authToken = `${userDatas.authToken}`;
      Object.entries({
        authToken: `${userDatas.authToken}`,
        UserName: userDatas.CustomerName,
        UserEmail: userDatas.EmailId,
        UserId: userDatas.CustomerId,
        CompanyId: userDatas.CompanyId,
        CompanyName: userDatas.Company_Name,
        BranchId: userDatas.BrnachID,
        Branch_Name: userDatas.Branch_Name,
        loginType: 'Customer',
        userRole: 'Customer',
        NewOrderPopupShown: 'N',
      }).forEach(([key, value]) => sessionStorage.setItem(key, value));
    }

    setTimeout(() => {
      if (userDatas) navigate('/dashboard/manage/booking', { replace: true });
      setError('');
      setErrorColor('');
      setLoading(false);
    }, 2000);
  };

  // useEffect(() => {
  //   sessionStorage.setItem('country', 'IN');
  //   sessionStorage.setItem('countryName', 'INDIA - UNITED KINGDOM');
  //   axios.defaults.headers.country = 'IN';
  // }, []);

  const loginStatusForCompany = (msg, color, userDatas) => {
    setError(msg);
    setErrorColor(color);
    if (userDatas) {
      axios.defaults.headers.authToken = `${userDatas.authToken}`;
      Object.entries({
        authToken: `${userDatas.authToken}`,
        UserName: userDatas.User_Name,
        UserEmail: userDatas.Emailid,
        Authorization: userDatas.Authorization,
        // SplUserId: userDatas.SplUserId,
        WebAccess: userDatas.WebAccess,
        // SplUserEmail: userDatas.SplUserEmail,
        UserId: userDatas.User_Id,
        CompanyId: 4,
        CompanyName: 'Teeparam',
        loginType: 'Company',
        userRole:
          userDatas.Authorization === 'Y' ? 'Admin' : userDatas.salesExecutiveLog === 'Y' ? 'Sales' : 'CompanyUser',
      }).forEach(([key, value]) => sessionStorage.setItem(key, value));
    }

    setTimeout(() => {
      if (userDatas) {
        const route =
          userDatas.Authorization === 'Y'
            ? '/dashboard/home'
            : userDatas.salesExecutiveLog === 'Y'
              ? '/dashboard/home'
              : '/dashboard/manage/booking';

        navigate(route, { replace: true });
      }
      setError('');
      setErrorColor('');
      setLoading(false);
    }, 2000);
  };

  const handleClick = async ({ usercode: UserName, password: Password, Country }) => {
    setLoading(true);
    try {
      const response = await axios.post('/login', { UserName, Password });
      if (response.status === 200 && response.data.authToken) {
        sessionStorage.setItem('Origin', Country);
        // sessionStorage.setItem('Origin', (Country === 'IN-UK' || Country === 'IN-SL') ? 'IN' : 'UK');
        if (response.data.LoginType === 'Customer') {
          loginStatus(
            `Welcome back, ${response.data.CustomerName}! You’ve successfully logged in.`,
            'green',
            response.data
          );
          setLoginType('Customer');
        } else {
          // setLoginData(response.data);
          loginStatusForCompany(
            `Welcome back, ${response.data.User_Name}! You’ve successfully logged in.`,
            'green',
            response.data
          );
          setLoginType('Company');
          // setValidationSchema(fullValidationSchema);
          setLoading(false);
        }
      } else {
        loginStatus('Invalid login credentials. Please try again.', 'error');
        setLoading(false);
      }
    } catch (e) {
      if(e.response?.data === 'SQL Query Error: Waiting'){
        loginStatus('Your account is awaiting approval. You will be notified once it is approved.', 'error');
      } else {
        loginStatus(e.response?.data || 'Something Went Wrong!', 'error');
      }
      setLoading(false);
    }
  };

  const handleOriginHeader = (e, handleChange, resetForm, selectedFullName) => {
    axios.defaults.headers.country = e.target.value;
    sessionStorage.setItem('country', e.target.value);
    // axios.defaults.headers.country = e.target.value === 'IN-UK' || e.target.value === 'IN-SL' ? 'IN' : 'UK';
    // sessionStorage.setItem('country', e.target.value === 'IN-UK' || e.target.value === 'IN-SL' ? 'IN' : 'UK');
    sessionStorage.setItem('countryName', selectedFullName);
    if (loginType === 'Company') {
      setLoginType('');
      resetForm();
    }
    handleChange(e);
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          minWidth:'100vw',
          top: 0,
          zIndex: 1100,
          backgroundColor: "#0072E5",
          padding: "6px 16px",
          display: "flex",
          justifyContent: mdUp ? "space-between" : "center",
          alignItems: "center",
          color: "#fff",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
        }}
      >
        {mdUp &&
          <>
            {/* Contact Information */}
            < Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <PhoneIcon />
                <Typography variant="subtitle2" sx={{ color: "#fff" }}>
                  <a
                    href="tel:+442037907773"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    020 3790 7773
                  </a>
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <EmailIcon />
                <Typography variant="subtitle2" sx={{ color: "#fff" }}>
                  <a
                    href="mailto:admin@teeparam.com"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    admin@teeparam.com
                  </a>
                </Typography>
              </Box>
            </Box>
          </>
        }

        <Button
          sx={{
            backgroundColor: "#00A44B",
            color: "#fff",
            padding: "4px 16px",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#007e3a",
            },
          }}
          size="small"
          onClick={() =>
            window.open(`${axios.defaults.TRACKING_URL}`, "_blank") }
        >
          TRACK YOUR SHIPMENT
        </Button>
      </Box >
      <StyledRoot>
        <StyledSection>
          <Container
            maxWidth="md"
            style={{
              backgroundColor: 'inherit',
              borderRadius: mdUp ? '50px' : 0,
              padding: mdUp ? '0 16px' : 0,
            }}
            component={Paper}
            elevation={0}
          >
            <Grid
              container
              style={{
                background: '#D6EFD8',
                boxShadow:
                  'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
                minHeight: mdUp ? '60vh' : '100vh',
                maxHeight: mdUp ? '100vh' : 'auto',
                borderRadius: mdUp ? '50px' : 0,
              }}
            >
              <Grid item xs={12} md={5} sx={{ maxHeight: mdUp ? '100%' : '30%' }}>
                <Stack
                  justifyContent={'center'}
                  direction={'column'}
                  alignItems={'center'}
                  height={'100%'}
                  className="font_style1"
                >
                  <Stack
                    justifyContent={'center'}
                    direction={'column'}
                    alignItems={'center'}
                    p={3}
                    sx={{ maxHeight: mdUp ? '100%' : 'auto' }}
                  >
                    <img
                      src={logoImage}
                      style={{
                        objectFit: 'contain',
                        maxWidth: mdUp ? '70%' : '50%',
                      }}
                      alt="techveel logo"
                    />
                    {mdUp ? (
                      <Typography
                        variant="h4"
                        textAlign={'center'}
                        gutterBottom
                        className="font_style2"
                        style={{ color: 'black' }}
                        mt={4}
                      >
                        Customer Satisfaction is Our Moto
                      </Typography>
                    ) : (
                      <Typography
                        variant="body2"
                        textAlign={'center'}
                        style={{ textTransform: 'uppercase' }}
                        gutterBottom
                        sx={{ marginTop: mdUp ? 'inherit' : '10px' }}
                      >
                        Welcome to <br />
                        <span style={{ textTransform: 'uppercase' }} className="font_style2">
                          Teeparam
                        </span>
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={12} md={7} justifyContent={'center'} alignItems={'center'}>
                <Stack
                  spacing={3}
                  sx={{ backgroundColor: 'white', p: 3, pb: 3, height: '100%' }}
                  style={{
                    borderTopRightRadius: mdUp ? '50px' : 0,
                    borderBottomRightRadius: mdUp ? '50px' : 0,
                  }}
                  justifyContent={'center'}
                >
                  <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                    <Grid item xs={12} p={0}>
                      {mdUp ? (
                        <Typography variant="body2" textAlign={'center'} gutterBottom>
                          Welcome to <br />
                          <span style={{ textTransform: 'uppercase', color: '#0D9276' }} className="font_style2">
                            TEEPARAM
                          </span>
                          <br />
                          <Typography
                            sx={{
                              color: forgotPassword ? 'error.main' : 'text.primary',
                            }}
                            fontSize={forgotPassword ? '1.175rem' : '0.875rem'}
                            variant="subtitle2"
                            textAlign={'center'}
                            gutterBottom
                          >
                            {forgotPassword ? 'Forgot Your Password' : 'Enter Your Credentials'}
                          </Typography>
                        </Typography>
                      ) : (
                        <Typography
                          sx={{
                            color: forgotPassword ? 'error.main' : 'text.primary',
                          }}
                          fontSize={forgotPassword ? '1.175rem' : '0.875rem'}
                          variant="subtitle2"
                          textAlign={'center'}
                          gutterBottom
                        >
                          {forgotPassword ? 'Forgot Your Password' : 'Enter Your Credentials'}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                  {forgotPassword ? (
                    <ForgotPassword setForgotPassword={setForgotPassword} />
                  ) : (
                    <Formik
                      // validationSchema={loginType === 'Company' ? validationSchema : minimalValidationSchema}
                      validationSchema={validationSchema}
                      initialValues={loginInitialValue}
                      onSubmit={(values) => {
                        handleClick(values);
                      }}
                    >
                      {({ values, errors, submitForm, handleBlur, handleChange, resetForm, touched }) => (
                        <Form>
                          <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                            <Grid item xs={12}>
                              <TextField
                                name="usercode"
                                label="Email Id"
                                size="small"
                                fullWidth
                                disabled={loginType === 'Company'}
                                InputLabelProps={{ shrink: true }}
                                value={values.usercode}
                                error={!!errors.usercode && touched.usercode}
                                helperText={touched.usercode && errors.usercode ? errors.usercode : ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{ autoComplete: 'off' }}
                                autoComplete="off"
                                onKeyDown={(event) => {
                                  if (event.key === 'Enter') {
                                    submitForm();
                                  }
                                }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <TextField
                                size="small"
                                // disabled={loginType === 'Company'}
                                fullWidth
                                name="password"
                                label="Password"
                                InputLabelProps={{ shrink: true }}
                                type={showUserPassword ? 'text' : 'password'}
                                autoComplete="off"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton onClick={() => setShowUserPassword(!showUserPassword)} edge="end">
                                        <Iconify icon={showUserPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!errors.password && touched.password}
                                helperText={touched.password && errors.password ? errors.password : ''}
                                onKeyDown={(event) => {
                                  if (event.key === 'Enter') {
                                    submitForm();
                                  }
                                }}
                              />
                            </Grid>

                            <Grid item md={12} xs={12}>
                              <FormControl fullWidth size="small" fullwidth>
                                <InputLabel id="Country-select-label">Book Order</InputLabel>
                                <Select
                                  fullWidth
                                  labelId="Country-select-label"
                                  value={values.Country}
                                  size="small"
                                  name="Country"
                                  label="Book Order"
                                  onChange={(e) => {
                                    const selectedCode = e.target.value;
                                    const selectedFullName = Object.keys(Countrys).find(
                                      (key) => Countrys[key] === selectedCode
                                    );
                                    handleOriginHeader(e, handleChange, resetForm, selectedFullName);
                                  }}
                                  error={touched.Country && !!errors.Country}
                                >
                                  {Object.entries(Countrys).map(([fullName, code]) => (
                                    <MenuItem key={fullName} value={code}>
                                      {fullName}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {touched.Country && errors.Country && (
                                  <Grid item xs={12}>
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="0 0 0 14px"
                                    >
                                      {errors.Country}
                                    </Typography>
                                  </Grid>
                                )}
                              </FormControl>
                            </Grid>

                            {error && (
                              <Grid item xs={12}>
                                <Typography variant="body2" color={errorColor} sx={{ textAlign: 'center' }}>
                                  {error}
                                </Typography>
                              </Grid>
                            )}
                            <Grid item xs={12}>
                              <LoadingButton
                                size="small"
                                fullWidth
                                type="button"
                                onClick={(e) => {
                                  submitForm(e);
                                }}
                                variant="contained"
                                loading={loading}
                              >
                                {'Login'}
                              </LoadingButton>
                            </Grid>
                            <Grid item xs={12}>
                              <Stack direction="row" p={0} m={0} justifyContent={'flex-end'}>
                                <LoadingButton
                                  size="small"
                                  // fullWidth
                                  // type="submit"
                                  variant="text"
                                  color="error"
                                  onClick={() => {
                                    setForgotPassword(true);
                                  }}
                                >
                                  Forgot Password?
                                </LoadingButton>
                              </Stack>
                            </Grid>
                            <Grid item xs={12}>
                              <LoadingButton
                                size="small"
                                fullWidth
                                // type="submit"
                                variant="text"
                                color="success"
                                onClick={() => {
                                  navigate('/signup', { replace: true });
                                }}
                              >
                                <span style={{ color: 'grey', marginRight: 2 }}> Ready to Ship? </span> Create your
                                account now!
                              </LoadingButton>
                            </Grid>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Container>
        </StyledSection>
      </StyledRoot>
    </>
  );
}
